import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type Domain = ObjectId & {
  hostname?: string;
};

type DomainAlreadyExistsInProjectErrorOptions = {
  domain: Domain;
  project: ObjectId;
};

export class DomainAlreadyExistsInProjectError extends FleekError<DomainAlreadyExistsInProjectErrorOptions> {
  public name = 'DomainAlreadyExistsInProjectError';

  toString = () => {
    return `Domain ${this.data.domain.hostname} already exists under the project.`;
  };
}
